// Major Indonesian cities with coordinates (for map centering & search)
const CITIES = [
  { name: "Jakarta", province: "DKI Jakarta", lat: -6.2088, lng: 106.8456 },
  { name: "Surabaya", province: "Jawa Timur", lat: -7.2575, lng: 112.7521 },
  { name: "Bandung", province: "Jawa Barat", lat: -6.9175, lng: 107.6191 },
  { name: "Medan", province: "Sumatera Utara", lat: 3.5952, lng: 98.6722 },
  { name: "Semarang", province: "Jawa Tengah", lat: -6.9667, lng: 110.4167 },
  { name: "Makassar", province: "Sulawesi Selatan", lat: -5.1477, lng: 119.4327 },
  { name: "Palembang", province: "Sumatera Selatan", lat: -2.9761, lng: 104.7754 },
  { name: "Depok", province: "Jawa Barat", lat: -6.4025, lng: 106.7942 },
  { name: "Tangerang", province: "Banten", lat: -6.1781, lng: 106.6300 },
  { name: "Bekasi", province: "Jawa Barat", lat: -6.2383, lng: 106.9756 },
  { name: "Yogyakarta", province: "DI Yogyakarta", lat: -7.7956, lng: 110.3695 },
  { name: "Denpasar", province: "Bali", lat: -8.6705, lng: 115.2126 },
  { name: "Bogor", province: "Jawa Barat", lat: -6.5950, lng: 106.8166 },
  { name: "Malang", province: "Jawa Timur", lat: -7.9666, lng: 112.6326 },
  { name: "Padang", province: "Sumatera Barat", lat: -0.9471, lng: 100.4172 },
  { name: "Pekanbaru", province: "Riau", lat: 0.5071, lng: 101.4478 },
  { name: "Bandar Lampung", province: "Lampung", lat: -5.4294, lng: 105.2610 },
  { name: "Surakarta", province: "Jawa Tengah", lat: -7.5755, lng: 110.8243 },
  { name: "Balikpapan", province: "Kalimantan Timur", lat: -1.2379, lng: 116.8529 },
  { name: "Banjarmasin", province: "Kalimantan Selatan", lat: -3.3186, lng: 114.5944 },
  { name: "Samarinda", province: "Kalimantan Timur", lat: -0.5022, lng: 117.1536 },
  { name: "Pontianak", province: "Kalimantan Barat", lat: -0.0263, lng: 109.3425 },
  { name: "Manado", province: "Sulawesi Utara", lat: 1.4748, lng: 124.8421 },
  { name: "Cimahi", province: "Jawa Barat", lat: -6.8722, lng: 107.5424 },
  { name: "Batam", province: "Kepulauan Riau", lat: 1.1301, lng: 104.0529 },
  { name: "Jambi", province: "Jambi", lat: -1.6101, lng: 103.6131 },
  { name: "Cirebon", province: "Jawa Barat", lat: -6.7320, lng: 108.5523 },
  { name: "Sukabumi", province: "Jawa Barat", lat: -6.9277, lng: 106.9300 },
  { name: "Tasikmalaya", province: "Jawa Barat", lat: -7.3274, lng: 108.2207 },
  { name: "Mataram", province: "Nusa Tenggara Barat", lat: -8.5833, lng: 116.1167 },
  { name: "Kupang", province: "Nusa Tenggara Timur", lat: -10.1772, lng: 123.6070 },
  { name: "Ambon", province: "Maluku", lat: -3.6954, lng: 128.1814 },
  { name: "Jayapura", province: "Papua", lat: -2.5337, lng: 140.7181 },
  { name: "Serang", province: "Banten", lat: -6.1200, lng: 106.1503 },
  { name: "Kediri", province: "Jawa Timur", lat: -7.8480, lng: 112.0178 },
  { name: "Pekalongan", province: "Jawa Tengah", lat: -6.8886, lng: 109.6753 },
  { name: "Tegal", province: "Jawa Tengah", lat: -6.8694, lng: 109.1402 },
  { name: "Sidoarjo", province: "Jawa Timur", lat: -7.4478, lng: 112.7183 },
  { name: "Gresik", province: "Jawa Timur", lat: -7.1556, lng: 112.6531 },
  { name: "Purwokerto", province: "Jawa Tengah", lat: -7.4218, lng: 109.2345 },
];

export default CITIES;
